import axios from '@/services/axiosConfig'

const endPoint = {
	lookupCategoryList: instId => `/institute/${instId}/category/list`,
	lookupCategoryInfo: (instId, categoryId) =>
		`/institute/${instId}/category?id=${categoryId}`,
}

const categoryAPI = {
	lookupCategoryList: instId =>
		axios.get(endPoint.lookupCategoryList(instId)),
	lookupCategoryInfo: (instId, categoryId) =>
		axios.get(endPoint.lookupCategoryInfo(instId, categoryId)),
}

export default categoryAPI
